import Vue from 'vue'
import VueRouter from 'vue-router'
// import { component } from 'vue/types/umd';
// import store from "./../../src/store/index.js";
import axios from "axios";
import store from "../store/index";


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'homePage',
    component: () => import("../components/Home/homePage.vue"),
  },
  {
    path: '/refund-policy',
    name: 'refundpolicy',
    component: () => import("../components/Home/refundpolicy.vue"),
  },
  {
    path: '/terms-and-conditions',
    name: 'termsandconditions',
    component: () => import("../components/Home/termsandconditions.vue"),
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import("../components/SignUp.vue"),
  },
  {
    path: '/signupNew',
    name: 'signupNew',
    component: () => import("../components/SignUpNew.vue"),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import("../components/LogIn.vue"),
  },
  {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    component: () => import("../components/ForgotPassword.vue"),
  },
  {
    path: '/subscription',
    name: 'subscription',
    component: () => import("../components/SubscriptionPage.vue"),
  },
  {
    path: '/subNoOverlay',
    name: 'subNoOverlay',
    component: () => import("../components/ComponentPages/SubscriptionTestNoOverlay.vue"),
  },
  {
    path: '/waitingPage',
    name: 'waitingPage',
    component: () => import("../components/waitingPage.vue"),
  },
  {
    path: '/teamSubscription',
    name: 'teamSubscription',
    component: () => import("../components/TeamSubscription.vue"),
  },
  {
    path: '/teamSubscriptionRenew',
    name: 'teamSubscriptionRenew',
    component: () => import("../components/TeamSubscriptionRenew.vue"),
  },
  {
    path: '/Renew',
    name: 'Renew',
    component: () => import("../components/RenewSubscription.vue"),
  },
  {
    path: '/Upgrade',
    name: 'Upgrade',
    component: () => import("../components/UpgradeSubscription.vue"),
  },
  {
    path: '/UpgradePaid',
    name: 'UpgradePaid',
    component: () => import("../components/UpgradePaidSubscription.vue"),
  },
  {
    path: '/payment',
    name: 'Payment',
    component: () => import("../components/Payment.vue"),
  },
  {
    path: '/paymentBulk',
    name: 'paymentBulk',
    component: () => import("../components/BulkPayment.vue"),
  },
  {
    path: '/paymentRenew',
    name: 'paymentRenew',
    component: () => import("../components/PaymentRenew.vue"),
  },
  {
    path: '/paymentUpgrade',
    name: 'paymentUpgrade',
    component: () => import("../components/PaymentUpgrade.vue"),
  },
  {
    path: '/PrivacyAndPolicy',
    name: 'PrivacyAndPolicy',
    component: () => import("../components/PrivacyAndPolicy.vue"),
  },
  {
    path: '/support',
    name: 'support',
    component: () => import("../components/SupportPage.vue"),
  },
  {
    path: '/test',
    name: 'HelloWorld',
    component: () => import("../components/HelloWorld.vue"),
  },
  {
    path: '/Profile',
    name: 'Profile',
    component: () => import("../components/ProfilePage.vue"),
  },

  // {
  //   path: '/Profile-test',
  //   name: 'Profile',
  //   component: () => import("../components/profileTest.vue"),
  // },

  {
    path: '/Settings',
    name: 'Settings',
    component: () => import("../components/SettingsPage.vue"),
  },
  {
    path: '/regDetailedView',
    name: 'FileRegisterDetail',
    component: () =>
        import ('../components/ComponentPages/My Projects/FileRegisterDetail.vue')
  },
  {
    path: '/Dashboard',
    name: 'Dashboard',
    component: () => import("../components/DashboardPage.vue"),
    meta : {
      requiresAuth: true,
    }
  },
  {
    path: '/DashboardC',
    name: 'DashboardC',
    component: () => import("../components/DashboardComponent.vue"),
    children: [{
      path: '',
      name: 'projectpage',
      component: () =>
          import ('../components/ComponentPages/My Projects/ProjectsPage.vue')
  },{
    path: '/departments',
    name: 'departments',
    component: () =>
        import ('../components/ComponentPages/My Projects/DepartmentsPage.vue')
},
{
  path: '/fileRegister',
  name: 'FileRegister',
  component: () =>
      import ('../components/FileRegister.vue')
},
{
      path: '/folders',
      name: 'folders',
      component: () =>
          import ('../components/ComponentPages/My Projects/FoldersPage.vue'),
      children: [{
        path: '/recentupdates',
        name: 'recentupdates',
        component: () =>
            import ('../components/ComponentPages/My Projects/RecentUpdates.vue')
        },{
          path: '/selectedfile',
          name: 'selectedfile',
          component: () =>
              import ('../components/ComponentPages/My Projects/SelectedFile.vue')
        },
      ]
  },
  {
    path: '/workList',
    name: 'WorkList',
    component: () =>
        import ('../components/ComponentPages/My Projects/WorkList.vue')
},
  {
    path: '/projecttimeline',
    name: 'projecttimeline',
    component: () =>
        import ('../components/ComponentPages/My Projects/ProjectTimeline.vue')
},

{
  path: '/timelineAcknowledge',
  name: 'TimelineAcknowledge',
  component: () =>
      import ('../components/ComponentPages/My Projects/TimelineAcknowledge.vue')
},


  {
    path: '/myworklist',
    name: 'myworklist',
    component: () =>
        import ('../components/ComponentPages/MyWorklist/TabPage')
  }, 
  
  {
    path: '/myrequest',
    name: 'myrequest',
    component: () =>import ('../components/ComponentPages/MyRequest/RequestTab.vue'),
  }, 

  // {
  //   path: '/myrequestBackup',
  //   name: 'myrequest',
  //   component: () =>import ('../components/ComponentPages/MyRequest/RequestTabBackup.vue'),
  // }, 
]


    
  },

  
  {
    path: '/timeline',
    name: 'timeline',
    component: () =>
        import ('../components/ComponentPages/MyWorklist/TimelinePage.vue')
  },
  {
    path: '/tasks',
    name: 'tasks',
    component: () =>
        import ('../components/ComponentPages/MyWorklist/TaskPage.vue')
  },
  {
    path: '/request',
    name: 'request',
    component: () =>
        import ('../components/ComponentPages/MyWorklist/FilerequestPage.vue')
  },
  // {
  //   path: '/departments',
  //   name: 'departments',
  //   component: () => import("../components/ComponentPages/DepartmentPage"),
  // },
  {
    path: '/recentuploads',
    name: 'recentuploads',
    component: () => import("../components/ComponentPages/RecentUploads.vue"),
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import("../components/ComponentPages/My Projects/ProjectsPage.vue"),
  },
 
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});


router.beforeEach((to, from, next) => {
  if (
    to.matched.some(route => route.meta.requiresAuth == true) &&
    store.state.isLoggedIn == false
  ) {
    console.log(from);
    next({ name: "login", params: { lastPage: from } });
    return
  }


  if (store.state.isLoggedIn) {
    const excludedRoutes = ['/teamSubscription', '/payment', '/paymentRenew', '/paymentUpgrade', '/waitingPage'];
    
    const currentPath = router.currentRoute.value ? router.currentRoute.value.fullPath : router.currentRoute.path;
  
    if (!excludedRoutes.includes(currentPath)) {
      let userData = {};
      let noRestriction = false;
      let listAndView = false;
      let fileUploadLimit = false;
      let uploadLimit = 0;
      let fileRegister = false;
      let fileExport = false;
      let planEndsIn = 0;
      let isFree = false;
      let isBulkSubscription = false;
    
      axios({
        method: "GET",
        url: "/authenticate",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (!response.data.status) {
            store.commit("sessionOut", true);
            return;
          } else {
            userData = response.data.data || response.data;
            
            fileRegister = response.data.isFileRegisterAvailable;
            fileExport = response.data.isFileExportAvailable;
            planEndsIn = response.data.planEndsIn;
            isFree = response.data.isFree;
            isBulkSubscription = response.data.isBulkSubscription;
            // Check if the plan is selected
            if (!userData.isPlanSelected) {
              console.log("plan selectednn:", userData.isPlanSelected);
              if (currentPath !== '/subscription') {
                router.push('/subscription').catch(err => {
                  if (err.name !== 'NavigationDuplicated') {
                    console.error(err);
                  }
                });
              }
            } else {
              console.log("status:" ,userData.planStatus)
              if (userData.planStatus !== 'Active' && router.currentRoute.path !== '/Renew' && router.currentRoute.path !== '/teamSubscription' && router.currentRoute.path !== '/teamSubscriptionRenew') {
                console.log("haii")
                router.push('/profile');
                console.log("status:" ,userData.planStatus)
              }
              // If the user is on trial
              if (userData.isOnTrial) {
                noRestriction = true;
                listAndView = false;
                localStorage.setItem('noRestriction', true);
                localStorage.setItem('listAndView', false);
                console.log('listAndView on trial:', listAndView);
              }
    
              // If the user is not on trial
              if (!userData.isOnTrial) {
                if (userData.isLimitedAccess) {
                  listAndView = true;
                  localStorage.setItem('listAndView', true);
                  console.log('listAndView TTT:', listAndView);

                } else if (userData.isFileUploadLimited) {
                  fileUploadLimit = true;
                  uploadLimit = userData.fileUploadLimit;
                  localStorage.setItem('fileUploadLimit', true);
                  localStorage.setItem('uploadLimit', uploadLimit.toString());
                  console.log('uploadLimit:', uploadLimit);
                  console.log('listAndView: C', listAndView);
                  localStorage.setItem('listAndView', false);
                }
              }
            }


            if(userData.isFileRegisterAvailable){
              localStorage.setItem('fileRegister', true);
            }
            else{
              localStorage.setItem('fileRegister', false);
            }
            if(userData.isFileExportAvailable){
              localStorage.setItem('fileExport', true);
            }
            else{
              localStorage.setItem('fileExport', false);
            }
            if(userData.planEndsIn){
              localStorage.setItem('planEndsIn', userData.planEndsIn);
            }
            else{
              localStorage.removeItem('planEndsIn');
            }

            if(userData.isFree){
              localStorage.setItem('isFree', true);
            }
            else{
              localStorage.setItem('isFree', false);
              // localStorage.removeItem('isFree');
            }

            if(userData.isBulkSubscription){
              localStorage.setItem('isBulkSubscription', userData.isBulkSubscription);
            }
            else{
              localStorage.removeItem('isBulkSubscription');
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
  
  
  

  if (
    (to.name == "login" || to.name == "home") &&
    store.state.isLoggedIn == true
  ) {
    next({ name: "Dashboard" });
    return;
  }
  next();
});

export default router;
